import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import EquipmentNav from '../EquipmentNav/EquipmentNav';
import { EquipmentData } from './EquipmentData';
import * as ReactDOMServer from 'react-dom/server';
import './style.scss';
import EquipmentSlide from '../EquipmentSlide/EquipmentSlide';
// import BigImg from '../../assets/images/1.png';
// import MidImg from '../../assets/images/5.png';
// import SmImg from '../../assets/images/6.png';

export interface INavigationData {
  title: string;
  subtitle: string;
  className?: string;
}

const navigationData: INavigationData[] = [
  {
    title: 'Пауэрбанк',
    subtitle: '5000мАч'
  },
  {
    title: 'Кубик',
    subtitle: '8 слотов'
  },
  {
    title: 'Стойка',
    subtitle: '24 слота'
  },
  {
    title: 'Гигант',
    subtitle: '48 слотов'
  }
];

const EquipmentSlider = () => {
  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      const { title, subtitle } = navigationData[index];
      return ReactDOMServer.renderToStaticMarkup(
        <EquipmentNav title={title} subtitle={subtitle} className={className} />
      );
    }
  };

  // const currentImage =
  //   window.innerWidth > 1599
  //     ? BigImg
  //     : window.innerWidth > 1135
  //     ? MidImg
  //     : SmImg;

  return (
    <>
      <Swiper
        pagination={pagination}
        modules={[Pagination]}
        className="mySwiper"
      >
        {EquipmentData.map(
          (
            {
              weight,
              subAdditional,
              energy,
              title,
              subtitle,
              specifications,
              img,
              gabarites,
              corpus,
              additional,
              icon,
              classN
            },
            index
          ) => (
            <SwiperSlide key={index}>
              <EquipmentSlide
                weight={weight}
                subAdditional={subAdditional}
                energy={energy}
                title={title}
                subtitle={subtitle}
                // img={title === 'Пауэрбанк' ? currentImage : img}
                img={img}
                specifications={specifications}
                corpus={corpus}
                additional={additional}
                gabarites={gabarites}
                icon={icon}
                classN={classN}
              />
            </SwiperSlide>
          )
        )}
      </Swiper>
    </>
  );
};

export default EquipmentSlider;
